import constants from './constants';

var GaugeSeriesYAxis = {
    minorTickInterval: 'auto',
    minorTickWidth: 1,
    minorTickLength: 10,
    minorTickPosition: 'inside',
    minorTickColor: '#666',
    tickPixelInterval: 30,
    tickWidth: 2,
    tickPosition: 'inside',
    tickLength: 10,
    tickColor: '#666',
    labels: {
        step: 2,
        rotation: 'auto'
    },
    plotBands: [{
        from: 0,
        to: {},
        color: {}
    }, {
        from: {},
        to: {},
        color: {}
    }, {
        from: {},
        to: {},
        color: {}
    }],
    min: 0,
    max: {}
};

var configureGaugeSeriesYAxis = function configureGaugeSeriesYAxis(widgetConfig, seriesDataObj) {
    var GaugeConfig = widgetConfig.GaugeConfig;


    if (GaugeConfig && GaugeConfig.GaugeType.toLowerCase() === constants.chartTypes.GAUGESERIES) {
        var valueMax = seriesDataObj[0][widgetConfig.GaugeConfig.ValueField];
        var finalMax = 2 * valueMax;
        var firstValue = finalMax * GaugeConfig.ThresholdField1 / 100;
        var secondValue = finalMax * GaugeConfig.ThresholdField2 / 100;
        var Color = GaugeConfig.Color,
            Color2 = GaugeConfig.Color2,
            Color3 = GaugeConfig.Color3;

        if (widgetConfig.GaugeConfig.MaxRange || widgetConfig.GaugeConfig.MaxValueField && widgetConfig.GaugeConfig.MaxValueField !== "--") finalMax = widgetConfig.GaugeConfig.MaxRange > 0 ? widgetConfig.GaugeConfig.MaxRange : seriesDataObj[0][widgetConfig.GaugeConfig.MaxValueField];

        GaugeSeriesYAxis.max = finalMax;
        GaugeSeriesYAxis.plotBands[0].to = firstValue;
        GaugeSeriesYAxis.plotBands[1].from = firstValue;
        GaugeSeriesYAxis.plotBands[1].to = secondValue;
        GaugeSeriesYAxis.plotBands[2].from = secondValue;
        GaugeSeriesYAxis.plotBands[2].to = finalMax;
        GaugeSeriesYAxis.plotBands[0].color = Color;
        GaugeSeriesYAxis.plotBands[1].color = Color2;
        GaugeSeriesYAxis.plotBands[2].color = Color3;
    }
    return GaugeSeriesYAxis;
};

export default configureGaugeSeriesYAxis;